import { boolPropsToClassNames } from 'common/utils/style.utils';
import { StyledDelta } from '../Tooltip.style';
import { getDeltaProps } from '../tooltip.utils';

const DeltaText = ({ delta, granularity, hidden }) => {
  const { isNegative, isPositive, absValue, isNA } = getDeltaProps(delta);
  const deltaText = isNA ? 'N/A' : `${absValue}% ${isNegative ? 'down' : 'up'}`;

  return (
    <StyledDelta
      className={boolPropsToClassNames({ isNegative, isPositive, hidden })}
      data-testid='delta-text'
    >
      - {deltaText} from last {granularity?.single}
    </StyledDelta>
  );
};

export default DeltaText;
